export const LIBRARY_NAME = '@trustedshops/tswp-core-common-diag-instana';
